var __create = Object.create, __defProp = Object.defineProperty, __getOwnPropDesc = Object.getOwnPropertyDescriptor, __getOwnPropNames = Object.getOwnPropertyNames, __getProtoOf = Object.getPrototypeOf, __hasOwnProp = Object.prototype.hasOwnProperty, __commonJSMin = (m, U) => () => (U || m((U = { exports: {} }).exports, U), U.exports), __export = (m, W) => {
	let G = {};
	for (var K in m) __defProp(G, K, {
		get: m[K],
		enumerable: !0
	});
	return W && __defProp(G, Symbol.toStringTag, { value: "Module" }), G;
}, __copyProps = (m, K, J, Y) => {
	if (K && typeof K == "object" || typeof K == "function") for (var X = __getOwnPropNames(K), Z = 0, Q = X.length, $; Z < Q; Z++) $ = X[Z], !__hasOwnProp.call(m, $) && $ !== J && __defProp(m, $, {
		get: ((m) => K[m]).bind(null, $),
		enumerable: !(Y = __getOwnPropDesc(K, $)) || Y.enumerable
	});
	return m;
}, __toESM = (W, G, q) => (q = W == null ? {} : __create(__getProtoOf(W)), __copyProps(G || !W || !W.__esModule ? __defProp(q, "default", {
	value: W,
	enumerable: !0
}) : q, W)), WINDOWS_1252_EXTRA = {
	128: "€",
	130: "‚",
	131: "ƒ",
	132: "„",
	133: "…",
	134: "†",
	135: "‡",
	136: "ˆ",
	137: "‰",
	138: "Š",
	139: "‹",
	140: "Œ",
	142: "Ž",
	145: "‘",
	146: "’",
	147: "“",
	148: "”",
	149: "•",
	150: "–",
	151: "—",
	152: "˜",
	153: "™",
	154: "š",
	155: "›",
	156: "œ",
	158: "ž",
	159: "Ÿ"
}, WINDOWS_1252_REVERSE = {};
for (let [m, U] of Object.entries(WINDOWS_1252_EXTRA)) WINDOWS_1252_REVERSE[U] = Number.parseInt(m, 10);
var _utf8Decoder;
function utf8Decoder() {
	if (globalThis.TextDecoder !== void 0) return _utf8Decoder ??= new globalThis.TextDecoder("utf-8");
}
var CHUNK = 32 * 1024, REPLACEMENT = 65533;
function textDecode(m, U = "utf-8") {
	switch (U.toLowerCase()) {
		case "utf-8":
		case "utf8": {
			let U = utf8Decoder();
			return U ? U.decode(m) : decodeUTF8(m);
		}
		case "utf-16le": return decodeUTF16LE(m);
		case "us-ascii":
		case "ascii": return decodeASCII(m);
		case "latin1":
		case "iso-8859-1": return decodeLatin1(m);
		case "windows-1252": return decodeWindows1252(m);
		default: throw RangeError(`Encoding '${U}' not supported`);
	}
}
function flushChunk(m, U) {
	U.length !== 0 && (m.push(String.fromCharCode.apply(null, U)), U.length = 0);
}
function pushCodeUnit(m, U, W) {
	U.push(W), U.length >= CHUNK && flushChunk(m, U);
}
function pushCodePoint(m, U, W) {
	if (W <= 65535) {
		pushCodeUnit(m, U, W);
		return;
	}
	W -= 65536, pushCodeUnit(m, U, 55296 + (W >> 10)), pushCodeUnit(m, U, 56320 + (W & 1023));
}
function decodeUTF8(m) {
	let U = [], W = [], G = 0;
	for (m.length >= 3 && m[0] === 239 && m[1] === 187 && m[2] === 191 && (G = 3); G < m.length;) {
		let K = m[G];
		if (K <= 127) {
			pushCodeUnit(U, W, K), G++;
			continue;
		}
		if (K < 194 || K > 244) {
			pushCodeUnit(U, W, REPLACEMENT), G++;
			continue;
		}
		if (K <= 223) {
			if (G + 1 >= m.length) {
				pushCodeUnit(U, W, REPLACEMENT), G++;
				continue;
			}
			let q = m[G + 1];
			if ((q & 192) != 128) {
				pushCodeUnit(U, W, REPLACEMENT), G++;
				continue;
			}
			pushCodeUnit(U, W, (K & 31) << 6 | q & 63), G += 2;
			continue;
		}
		if (K <= 239) {
			if (G + 2 >= m.length) {
				pushCodeUnit(U, W, REPLACEMENT), G++;
				continue;
			}
			let q = m[G + 1], J = m[G + 2];
			if (!((q & 192) == 128 && (J & 192) == 128 && !(K === 224 && q < 160) && !(K === 237 && q >= 160))) {
				pushCodeUnit(U, W, REPLACEMENT), G++;
				continue;
			}
			pushCodeUnit(U, W, (K & 15) << 12 | (q & 63) << 6 | J & 63), G += 3;
			continue;
		}
		if (G + 3 >= m.length) {
			pushCodeUnit(U, W, REPLACEMENT), G++;
			continue;
		}
		let q = m[G + 1], J = m[G + 2], Y = m[G + 3];
		if (!((q & 192) == 128 && (J & 192) == 128 && (Y & 192) == 128 && !(K === 240 && q < 144) && !(K === 244 && q > 143))) {
			pushCodeUnit(U, W, REPLACEMENT), G++;
			continue;
		}
		pushCodePoint(U, W, (K & 7) << 18 | (q & 63) << 12 | (J & 63) << 6 | Y & 63), G += 4;
	}
	return flushChunk(U, W), U.join("");
}
function decodeUTF16LE(m) {
	let U = [], W = [], G = m.length, K = 0;
	for (; K + 1 < G;) {
		let q = m[K] | m[K + 1] << 8;
		if (K += 2, q >= 55296 && q <= 56319) {
			if (K + 1 < G) {
				let G = m[K] | m[K + 1] << 8;
				G >= 56320 && G <= 57343 ? (pushCodeUnit(U, W, q), pushCodeUnit(U, W, G), K += 2) : pushCodeUnit(U, W, REPLACEMENT);
			} else pushCodeUnit(U, W, REPLACEMENT);
			continue;
		}
		if (q >= 56320 && q <= 57343) {
			pushCodeUnit(U, W, REPLACEMENT);
			continue;
		}
		pushCodeUnit(U, W, q);
	}
	return K < G && pushCodeUnit(U, W, REPLACEMENT), flushChunk(U, W), U.join("");
}
function decodeASCII(m) {
	let U = [];
	for (let W = 0; W < m.length; W += CHUNK) {
		let G = Math.min(m.length, W + CHUNK), K = Array(G - W);
		for (let U = W, q = 0; U < G; U++, q++) K[q] = m[U] & 127;
		U.push(String.fromCharCode.apply(null, K));
	}
	return U.join("");
}
function decodeLatin1(m) {
	let U = [];
	for (let W = 0; W < m.length; W += CHUNK) {
		let G = Math.min(m.length, W + CHUNK), K = Array(G - W);
		for (let U = W, q = 0; U < G; U++, q++) K[q] = m[U];
		U.push(String.fromCharCode.apply(null, K));
	}
	return U.join("");
}
function decodeWindows1252(m) {
	let U = [], W = "";
	for (let G = 0; G < m.length; G++) {
		let K = m[G], q = K >= 128 && K <= 159 ? WINDOWS_1252_EXTRA[K] : void 0;
		W += q ?? String.fromCharCode(K), W.length >= CHUNK && (U.push(W), W = "");
	}
	return W && U.push(W), U.join("");
}
function dv(m) {
	return new DataView(m.buffer, m.byteOffset);
}
const UINT8 = {
	len: 1,
	get(m, U) {
		return dv(m).getUint8(U);
	},
	put(m, U, W) {
		return dv(m).setUint8(U, W), U + 1;
	}
}, UINT16_LE = {
	len: 2,
	get(m, U) {
		return dv(m).getUint16(U, !0);
	},
	put(m, U, W) {
		return dv(m).setUint16(U, W, !0), U + 2;
	}
}, UINT16_BE = {
	len: 2,
	get(m, U) {
		return dv(m).getUint16(U);
	},
	put(m, U, W) {
		return dv(m).setUint16(U, W), U + 2;
	}
}, UINT32_LE = {
	len: 4,
	get(m, U) {
		return dv(m).getUint32(U, !0);
	},
	put(m, U, W) {
		return dv(m).setUint32(U, W, !0), U + 4;
	}
}, UINT32_BE = {
	len: 4,
	get(m, U) {
		return dv(m).getUint32(U);
	},
	put(m, U, W) {
		return dv(m).setUint32(U, W), U + 4;
	}
}, INT32_BE = {
	len: 4,
	get(m, U) {
		return dv(m).getInt32(U);
	},
	put(m, U, W) {
		return dv(m).setInt32(U, W), U + 4;
	}
}, UINT64_LE = {
	len: 8,
	get(m, U) {
		return dv(m).getBigUint64(U, !0);
	},
	put(m, U, W) {
		return dv(m).setBigUint64(U, W, !0), U + 8;
	}
};
var StringType = class {
	constructor(m, U) {
		this.len = m, this.encoding = U;
	}
	get(m, U = 0) {
		return textDecode(m.subarray(U, U + this.len), this.encoding);
	}
}, EndOfStreamError = class extends Error {
	constructor() {
		super("End-Of-Stream"), this.name = "EndOfStreamError";
	}
}, AbortError = class extends Error {
	constructor(m = "The operation was aborted") {
		super(m), this.name = "AbortError";
	}
}, AbstractStreamReader = class {
	constructor() {
		this.endOfStream = !1, this.interrupted = !1, this.peekQueue = [];
	}
	async peek(m, U = !1) {
		let W = await this.read(m, U);
		return this.peekQueue.push(m.subarray(0, W)), W;
	}
	async read(m, U = !1) {
		if (m.length === 0) return 0;
		let W = this.readFromPeekBuffer(m);
		if (this.endOfStream || (W += await this.readRemainderFromStream(m.subarray(W), U)), W === 0 && !U) throw new EndOfStreamError();
		return W;
	}
	readFromPeekBuffer(m) {
		let U = m.length, W = 0;
		for (; this.peekQueue.length > 0 && U > 0;) {
			let G = this.peekQueue.pop();
			if (!G) throw Error("peekData should be defined");
			let K = Math.min(G.length, U);
			m.set(G.subarray(0, K), W), W += K, U -= K, K < G.length && this.peekQueue.push(G.subarray(K));
		}
		return W;
	}
	async readRemainderFromStream(m, U) {
		let W = 0;
		for (; W < m.length && !this.endOfStream;) {
			if (this.interrupted) throw new AbortError();
			let G = await this.readFromStream(m.subarray(W), U);
			if (G === 0) break;
			W += G;
		}
		if (!U && W < m.length) throw new EndOfStreamError();
		return W;
	}
}, WebStreamReader = class extends AbstractStreamReader {
	constructor(m) {
		super(), this.reader = m;
	}
	async abort() {
		return this.close();
	}
	async close() {
		this.reader.releaseLock();
	}
}, WebStreamByobReader = class extends WebStreamReader {
	async readFromStream(m, U) {
		if (m.length === 0) return 0;
		let W = await this.reader.read(new Uint8Array(m.length), { min: U ? void 0 : m.length });
		return W.done && (this.endOfStream = W.done), W.value ? (m.set(W.value), W.value.length) : 0;
	}
}, WebStreamDefaultReader = class extends AbstractStreamReader {
	constructor(m) {
		super(), this.reader = m, this.buffer = null;
	}
	writeChunk(m, U) {
		let W = Math.min(U.length, m.length);
		return m.set(U.subarray(0, W)), W < U.length ? this.buffer = U.subarray(W) : this.buffer = null, W;
	}
	async readFromStream(m, U) {
		if (m.length === 0) return 0;
		let W = 0;
		for (this.buffer && (W += this.writeChunk(m, this.buffer)); W < m.length && !this.endOfStream;) {
			let U = await this.reader.read();
			if (U.done) {
				this.endOfStream = !0;
				break;
			}
			U.value && (W += this.writeChunk(m.subarray(W), U.value));
		}
		if (!U && W === 0 && this.endOfStream) throw new EndOfStreamError();
		return W;
	}
	abort() {
		return this.interrupted = !0, this.reader.cancel();
	}
	async close() {
		await this.abort(), this.reader.releaseLock();
	}
};
function makeWebStreamReader(m) {
	try {
		let U = m.getReader({ mode: "byob" });
		return U instanceof ReadableStreamDefaultReader ? new WebStreamDefaultReader(U) : new WebStreamByobReader(U);
	} catch (U) {
		if (U instanceof TypeError) return new WebStreamDefaultReader(m.getReader());
		throw U;
	}
}
var AbstractTokenizer = class {
	constructor(m) {
		this.numBuffer = new Uint8Array(8), this.position = 0, this.onClose = m?.onClose, m?.abortSignal && m.abortSignal.addEventListener("abort", () => {
			this.abort();
		});
	}
	async readToken(m, U = this.position) {
		let W = new Uint8Array(m.len);
		if (await this.readBuffer(W, { position: U }) < m.len) throw new EndOfStreamError();
		return m.get(W, 0);
	}
	async peekToken(m, U = this.position) {
		let W = new Uint8Array(m.len);
		if (await this.peekBuffer(W, { position: U }) < m.len) throw new EndOfStreamError();
		return m.get(W, 0);
	}
	async readNumber(m) {
		if (await this.readBuffer(this.numBuffer, { length: m.len }) < m.len) throw new EndOfStreamError();
		return m.get(this.numBuffer, 0);
	}
	async peekNumber(m) {
		if (await this.peekBuffer(this.numBuffer, { length: m.len }) < m.len) throw new EndOfStreamError();
		return m.get(this.numBuffer, 0);
	}
	async ignore(m) {
		if (m < 0) throw RangeError("ignore length must be ≥ 0 bytes");
		if (this.fileInfo.size !== void 0) {
			let U = this.fileInfo.size - this.position;
			if (m > U) return this.position += U, U;
		}
		return this.position += m, m;
	}
	async close() {
		await this.abort(), await this.onClose?.();
	}
	normalizeOptions(m, U) {
		if (!this.supportsRandomAccess() && U && U.position !== void 0 && U.position < this.position) throw Error("`options.position` must be equal or greater than `tokenizer.position`");
		return {
			mayBeLess: !1,
			offset: 0,
			length: m.length,
			position: this.position,
			...U
		};
	}
	abort() {
		return Promise.resolve();
	}
}, maxBufferSize = 256e3, ReadStreamTokenizer = class extends AbstractTokenizer {
	constructor(m, U) {
		super(U), this.streamReader = m, this.fileInfo = U?.fileInfo ?? {};
	}
	async readBuffer(m, U) {
		let W = this.normalizeOptions(m, U), G = W.position - this.position;
		if (G > 0) return await this.ignore(G), this.readBuffer(m, U);
		if (G < 0) throw Error("`options.position` must be equal or greater than `tokenizer.position`");
		if (W.length === 0) return 0;
		let K = await this.streamReader.read(m.subarray(0, W.length), W.mayBeLess);
		if (this.position += K, (!U || !U.mayBeLess) && K < W.length) throw new EndOfStreamError();
		return K;
	}
	async peekBuffer(m, U) {
		let W = this.normalizeOptions(m, U), G = 0;
		if (W.position) {
			let U = W.position - this.position;
			if (U > 0) {
				let K = new Uint8Array(W.length + U);
				return G = await this.peekBuffer(K, { mayBeLess: W.mayBeLess }), m.set(K.subarray(U)), G - U;
			}
			if (U < 0) throw Error("Cannot peek from a negative offset in a stream");
		}
		if (W.length > 0) {
			try {
				G = await this.streamReader.peek(m.subarray(0, W.length), W.mayBeLess);
			} catch (m) {
				if (U?.mayBeLess && m instanceof EndOfStreamError) return 0;
				throw m;
			}
			if (!W.mayBeLess && G < W.length) throw new EndOfStreamError();
		}
		return G;
	}
	async ignore(m) {
		if (m < 0) throw RangeError("ignore length must be ≥ 0 bytes");
		let U = Math.min(maxBufferSize, m), W = new Uint8Array(U), G = 0;
		for (; G < m;) {
			let K = m - G, q = await this.readBuffer(W, { length: Math.min(U, K) });
			if (q < 0) return q;
			G += q;
		}
		return G;
	}
	abort() {
		return this.streamReader.abort();
	}
	async close() {
		return this.streamReader.close();
	}
	supportsRandomAccess() {
		return !1;
	}
}, BufferTokenizer = class extends AbstractTokenizer {
	constructor(m, U) {
		super(U), this.uint8Array = m, this.fileInfo = {
			...U?.fileInfo ?? {},
			size: m.length
		};
	}
	async readBuffer(m, U) {
		U?.position && (this.position = U.position);
		let W = await this.peekBuffer(m, U);
		return this.position += W, W;
	}
	async peekBuffer(m, U) {
		let W = this.normalizeOptions(m, U), G = Math.min(this.uint8Array.length - W.position, W.length);
		if (!W.mayBeLess && G < W.length) throw new EndOfStreamError();
		return m.set(this.uint8Array.subarray(W.position, W.position + G)), G;
	}
	close() {
		return super.close();
	}
	supportsRandomAccess() {
		return !0;
	}
	setPosition(m) {
		this.position = m;
	}
}, BlobTokenizer = class extends AbstractTokenizer {
	constructor(m, U) {
		super(U), this.blob = m, this.fileInfo = {
			...U?.fileInfo ?? {},
			size: m.size,
			mimeType: m.type
		};
	}
	async readBuffer(m, U) {
		U?.position && (this.position = U.position);
		let W = await this.peekBuffer(m, U);
		return this.position += W, W;
	}
	async peekBuffer(m, U) {
		let W = this.normalizeOptions(m, U), G = Math.min(this.blob.size - W.position, W.length);
		if (!W.mayBeLess && G < W.length) throw new EndOfStreamError();
		let K = await this.blob.slice(W.position, W.position + G).arrayBuffer();
		return m.set(new Uint8Array(K)), G;
	}
	close() {
		return super.close();
	}
	supportsRandomAccess() {
		return !0;
	}
	setPosition(m) {
		this.position = m;
	}
};
function fromWebStream(m, U) {
	let W = makeWebStreamReader(m), G = U ?? {}, K = G.onClose;
	return G.onClose = async () => {
		if (await W.close(), K) return K();
	}, new ReadStreamTokenizer(W, G);
}
function fromBuffer(m, U) {
	return new BufferTokenizer(m, U);
}
function fromBlob(m, U) {
	return new BlobTokenizer(m, U);
}
var require_ms = /* @__PURE__ */ __commonJSMin(((m, U) => {
	var W = 1e3, G = W * 60, K = G * 60, q = K * 24, J = q * 7, Y = q * 365.25;
	U.exports = function(m, U) {
		U ||= {};
		var W = typeof m;
		if (W === "string" && m.length > 0) return X(m);
		if (W === "number" && isFinite(m)) return U.long ? Q(m) : Z(m);
		throw Error("val is not a non-empty string or a valid number. val=" + JSON.stringify(m));
	};
	function X(m) {
		if (m = String(m), !(m.length > 100)) {
			var U = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(m);
			if (U) {
				var X = parseFloat(U[1]);
				switch ((U[2] || "ms").toLowerCase()) {
					case "years":
					case "year":
					case "yrs":
					case "yr":
					case "y": return X * Y;
					case "weeks":
					case "week":
					case "w": return X * J;
					case "days":
					case "day":
					case "d": return X * q;
					case "hours":
					case "hour":
					case "hrs":
					case "hr":
					case "h": return X * K;
					case "minutes":
					case "minute":
					case "mins":
					case "min":
					case "m": return X * G;
					case "seconds":
					case "second":
					case "secs":
					case "sec":
					case "s": return X * W;
					case "milliseconds":
					case "millisecond":
					case "msecs":
					case "msec":
					case "ms": return X;
					default: return;
				}
			}
		}
	}
	function Z(m) {
		var U = Math.abs(m);
		return U >= q ? Math.round(m / q) + "d" : U >= K ? Math.round(m / K) + "h" : U >= G ? Math.round(m / G) + "m" : U >= W ? Math.round(m / W) + "s" : m + "ms";
	}
	function Q(m) {
		var U = Math.abs(m);
		return U >= q ? $(m, U, q, "day") : U >= K ? $(m, U, K, "hour") : U >= G ? $(m, U, G, "minute") : U >= W ? $(m, U, W, "second") : m + " ms";
	}
	function $(m, U, W, G) {
		var K = U >= W * 1.5;
		return Math.round(m / W) + " " + G + (K ? "s" : "");
	}
})), require_common = /* @__PURE__ */ __commonJSMin(((m, U) => {
	function W(m) {
		W.debug = W, W.default = W, W.coerce = X, W.disable = J, W.enable = K, W.enabled = Y, W.humanize = require_ms(), W.destroy = Z, Object.keys(m).forEach((U) => {
			W[U] = m[U];
		}), W.names = [], W.skips = [], W.formatters = {};
		function U(m) {
			let U = 0;
			for (let W = 0; W < m.length; W++) U = (U << 5) - U + m.charCodeAt(W), U |= 0;
			return W.colors[Math.abs(U) % W.colors.length];
		}
		W.selectColor = U;
		function W(m) {
			let U, K = null, q, J;
			function Y(...m) {
				if (!Y.enabled) return;
				let G = Y, K = Number(/* @__PURE__ */ new Date());
				G.diff = K - (U || K), G.prev = U, G.curr = K, U = K, m[0] = W.coerce(m[0]), typeof m[0] != "string" && m.unshift("%O");
				let q = 0;
				m[0] = m[0].replace(/%([a-zA-Z%])/g, (U, K) => {
					if (U === "%%") return "%";
					q++;
					let J = W.formatters[K];
					if (typeof J == "function") {
						let W = m[q];
						U = J.call(G, W), m.splice(q, 1), q--;
					}
					return U;
				}), W.formatArgs.call(G, m), (G.log || W.log).apply(G, m);
			}
			return Y.namespace = m, Y.useColors = W.useColors(), Y.color = W.selectColor(m), Y.extend = G, Y.destroy = W.destroy, Object.defineProperty(Y, "enabled", {
				enumerable: !0,
				configurable: !1,
				get: () => K === null ? (q !== W.namespaces && (q = W.namespaces, J = W.enabled(m)), J) : K,
				set: (m) => {
					K = m;
				}
			}), typeof W.init == "function" && W.init(Y), Y;
		}
		function G(m, U) {
			let G = W(this.namespace + (U === void 0 ? ":" : U) + m);
			return G.log = this.log, G;
		}
		function K(m) {
			W.save(m), W.namespaces = m, W.names = [], W.skips = [];
			let U = (typeof m == "string" ? m : "").trim().replace(/\s+/g, ",").split(",").filter(Boolean);
			for (let m of U) m[0] === "-" ? W.skips.push(m.slice(1)) : W.names.push(m);
		}
		function q(m, U) {
			let W = 0, G = 0, K = -1, q = 0;
			for (; W < m.length;) if (G < U.length && (U[G] === m[W] || U[G] === "*")) U[G] === "*" ? (K = G, q = W, G++) : (W++, G++);
			else if (K !== -1) G = K + 1, q++, W = q;
			else return !1;
			for (; G < U.length && U[G] === "*";) G++;
			return G === U.length;
		}
		function J() {
			let m = [...W.names, ...W.skips.map((m) => "-" + m)].join(",");
			return W.enable(""), m;
		}
		function Y(m) {
			for (let U of W.skips) if (q(m, U)) return !1;
			for (let U of W.names) if (q(m, U)) return !0;
			return !1;
		}
		function X(m) {
			return m instanceof Error ? m.stack || m.message : m;
		}
		function Z() {
			console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");
		}
		return W.enable(W.load()), W;
	}
	U.exports = W;
})), require_browser = /* @__PURE__ */ __commonJSMin(((m, U) => {
	m.formatArgs = G, m.save = K, m.load = q, m.useColors = W, m.storage = J(), m.destroy = (() => {
		let m = !1;
		return () => {
			m || (m = !0, console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`."));
		};
	})(), m.colors = /* @__PURE__ */ "#0000CC.#0000FF.#0033CC.#0033FF.#0066CC.#0066FF.#0099CC.#0099FF.#00CC00.#00CC33.#00CC66.#00CC99.#00CCCC.#00CCFF.#3300CC.#3300FF.#3333CC.#3333FF.#3366CC.#3366FF.#3399CC.#3399FF.#33CC00.#33CC33.#33CC66.#33CC99.#33CCCC.#33CCFF.#6600CC.#6600FF.#6633CC.#6633FF.#66CC00.#66CC33.#9900CC.#9900FF.#9933CC.#9933FF.#99CC00.#99CC33.#CC0000.#CC0033.#CC0066.#CC0099.#CC00CC.#CC00FF.#CC3300.#CC3333.#CC3366.#CC3399.#CC33CC.#CC33FF.#CC6600.#CC6633.#CC9900.#CC9933.#CCCC00.#CCCC33.#FF0000.#FF0033.#FF0066.#FF0099.#FF00CC.#FF00FF.#FF3300.#FF3333.#FF3366.#FF3399.#FF33CC.#FF33FF.#FF6600.#FF6633.#FF9900.#FF9933.#FFCC00.#FFCC33".split(".");
	function W() {
		if (typeof window < "u" && window.process && (window.process.type === "renderer" || window.process.__nwjs)) return !0;
		if (typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) return !1;
		let m;
		return typeof document < "u" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || typeof window < "u" && window.console && (window.console.firebug || window.console.exception && window.console.table) || typeof navigator < "u" && navigator.userAgent && (m = navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/)) && parseInt(m[1], 10) >= 31 || typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
	}
	function G(m) {
		if (m[0] = (this.useColors ? "%c" : "") + this.namespace + (this.useColors ? " %c" : " ") + m[0] + (this.useColors ? "%c " : " ") + "+" + U.exports.humanize(this.diff), !this.useColors) return;
		let W = "color: " + this.color;
		m.splice(1, 0, W, "color: inherit");
		let G = 0, K = 0;
		m[0].replace(/%[a-zA-Z%]/g, (m) => {
			m !== "%%" && (G++, m === "%c" && (K = G));
		}), m.splice(K, 0, W);
	}
	m.log = console.debug || console.log || (() => {});
	function K(U) {
		try {
			U ? m.storage.setItem("debug", U) : m.storage.removeItem("debug");
		} catch {}
	}
	function q() {
		let U;
		try {
			U = m.storage.getItem("debug") || m.storage.getItem("DEBUG");
		} catch {}
		return !U && typeof process < "u" && "env" in process && (U = process.env.DEBUG), U;
	}
	function J() {
		try {
			return localStorage;
		} catch {}
	}
	U.exports = require_common()(m);
	var { formatters: Y } = U.exports;
	Y.j = function(m) {
		try {
			return JSON.stringify(m);
		} catch (m) {
			return "[UnexpectedJSONParseError]: " + m.message;
		}
	};
}));
const Signature = {
	LocalFileHeader: 67324752,
	DataDescriptor: 134695760,
	CentralFileHeader: 33639248,
	EndOfCentralDirectory: 101010256
}, DataDescriptor = {
	get(m) {
		return {
			signature: UINT32_LE.get(m, 0),
			compressedSize: UINT32_LE.get(m, 8),
			uncompressedSize: UINT32_LE.get(m, 12)
		};
	},
	len: 16
}, LocalFileHeaderToken = {
	get(m) {
		let U = UINT16_LE.get(m, 6);
		return {
			signature: UINT32_LE.get(m, 0),
			minVersion: UINT16_LE.get(m, 4),
			dataDescriptor: !!(U & 8),
			compressedMethod: UINT16_LE.get(m, 8),
			compressedSize: UINT32_LE.get(m, 18),
			uncompressedSize: UINT32_LE.get(m, 22),
			filenameLength: UINT16_LE.get(m, 26),
			extraFieldLength: UINT16_LE.get(m, 28),
			filename: null
		};
	},
	len: 30
}, EndOfCentralDirectoryRecordToken = {
	get(m) {
		return {
			signature: UINT32_LE.get(m, 0),
			nrOfThisDisk: UINT16_LE.get(m, 4),
			nrOfThisDiskWithTheStart: UINT16_LE.get(m, 6),
			nrOfEntriesOnThisDisk: UINT16_LE.get(m, 8),
			nrOfEntriesOfSize: UINT16_LE.get(m, 10),
			sizeOfCd: UINT32_LE.get(m, 12),
			offsetOfStartOfCd: UINT32_LE.get(m, 16),
			zipFileCommentLength: UINT16_LE.get(m, 20)
		};
	},
	len: 22
}, FileHeader = {
	get(m) {
		let U = UINT16_LE.get(m, 8);
		return {
			signature: UINT32_LE.get(m, 0),
			minVersion: UINT16_LE.get(m, 6),
			dataDescriptor: !!(U & 8),
			compressedMethod: UINT16_LE.get(m, 10),
			compressedSize: UINT32_LE.get(m, 20),
			uncompressedSize: UINT32_LE.get(m, 24),
			filenameLength: UINT16_LE.get(m, 28),
			extraFieldLength: UINT16_LE.get(m, 30),
			fileCommentLength: UINT16_LE.get(m, 32),
			relativeOffsetOfLocalHeader: UINT32_LE.get(m, 42),
			filename: null
		};
	},
	len: 46
};
var import_browser = /* @__PURE__ */ __toESM(require_browser(), 1);
function signatureToArray(m) {
	let U = new Uint8Array(UINT32_LE.len);
	return UINT32_LE.put(U, 0, m), U;
}
var debug = (0, import_browser.default)("tokenizer:inflate"), syncBufferSize = 256 * 1024, ddSignatureArray = signatureToArray(Signature.DataDescriptor), eocdSignatureBytes = signatureToArray(Signature.EndOfCentralDirectory), ZipHandler = class m {
	constructor(m) {
		this.tokenizer = m, this.syncBuffer = new Uint8Array(syncBufferSize);
	}
	async isZip() {
		return await this.peekSignature() === Signature.LocalFileHeader;
	}
	peekSignature() {
		return this.tokenizer.peekToken(UINT32_LE);
	}
	async findEndOfCentralDirectoryLocator() {
		let m = this.tokenizer, U = Math.min(16 * 1024, m.fileInfo.size), W = this.syncBuffer.subarray(0, U);
		await this.tokenizer.readBuffer(W, { position: m.fileInfo.size - U });
		for (let G = W.length - 4; G >= 0; G--) if (W[G] === eocdSignatureBytes[0] && W[G + 1] === eocdSignatureBytes[1] && W[G + 2] === eocdSignatureBytes[2] && W[G + 3] === eocdSignatureBytes[3]) return m.fileInfo.size - U + G;
		return -1;
	}
	async readCentralDirectory() {
		if (!this.tokenizer.supportsRandomAccess()) {
			debug("Cannot reading central-directory without random-read support");
			return;
		}
		debug("Reading central-directory...");
		let m = this.tokenizer.position, U = await this.findEndOfCentralDirectoryLocator();
		if (U > 0) {
			debug("Central-directory 32-bit signature found");
			let W = await this.tokenizer.readToken(EndOfCentralDirectoryRecordToken, U), G = [];
			this.tokenizer.setPosition(W.offsetOfStartOfCd);
			for (let m = 0; m < W.nrOfEntriesOfSize; ++m) {
				let U = await this.tokenizer.readToken(FileHeader);
				if (U.signature !== Signature.CentralFileHeader) throw Error("Expected Central-File-Header signature");
				U.filename = await this.tokenizer.readToken(new StringType(U.filenameLength, "utf-8")), await this.tokenizer.ignore(U.extraFieldLength), await this.tokenizer.ignore(U.fileCommentLength), G.push(U), debug(`Add central-directory file-entry: n=${m + 1}/${G.length}: filename=${G[m].filename}`);
			}
			return this.tokenizer.setPosition(m), G;
		}
		this.tokenizer.setPosition(m);
	}
	async unzip(m) {
		let U = await this.readCentralDirectory();
		if (U) return this.iterateOverCentralDirectory(U, m);
		let W = !1;
		do {
			let U = await this.readLocalFileHeader();
			if (!U) break;
			let G = m(U);
			W = !!G.stop;
			let K;
			if (await this.tokenizer.ignore(U.extraFieldLength), U.dataDescriptor && U.compressedSize === 0) {
				let m = [], W = syncBufferSize;
				debug("Compressed-file-size unknown, scanning for next data-descriptor-signature....");
				let K = -1;
				for (; K < 0 && W === syncBufferSize;) {
					W = await this.tokenizer.peekBuffer(this.syncBuffer, { mayBeLess: !0 }), K = indexOf(this.syncBuffer.subarray(0, W), ddSignatureArray);
					let U = K >= 0 ? K : W;
					if (G.handler) {
						let W = new Uint8Array(U);
						await this.tokenizer.readBuffer(W), m.push(W);
					} else await this.tokenizer.ignore(U);
				}
				debug(`Found data-descriptor-signature at pos=${this.tokenizer.position}`), G.handler && await this.inflate(U, mergeArrays(m), G.handler);
			} else G.handler ? (debug(`Reading compressed-file-data: ${U.compressedSize} bytes`), K = new Uint8Array(U.compressedSize), await this.tokenizer.readBuffer(K), await this.inflate(U, K, G.handler)) : (debug(`Ignoring compressed-file-data: ${U.compressedSize} bytes`), await this.tokenizer.ignore(U.compressedSize));
			if (debug(`Reading data-descriptor at pos=${this.tokenizer.position}`), U.dataDescriptor && (await this.tokenizer.readToken(DataDescriptor)).signature !== 134695760) throw Error(`Expected data-descriptor-signature at position ${this.tokenizer.position - DataDescriptor.len}`);
		} while (!W);
	}
	async iterateOverCentralDirectory(m, U) {
		for (let W of m) {
			let m = U(W);
			if (m.handler) {
				this.tokenizer.setPosition(W.relativeOffsetOfLocalHeader);
				let U = await this.readLocalFileHeader();
				if (U) {
					await this.tokenizer.ignore(U.extraFieldLength);
					let G = new Uint8Array(W.compressedSize);
					await this.tokenizer.readBuffer(G), await this.inflate(U, G, m.handler);
				}
			}
			if (m.stop) break;
		}
	}
	async inflate(U, W, G) {
		if (U.compressedMethod === 0) return G(W);
		if (U.compressedMethod !== 8) throw Error(`Unsupported ZIP compression method: ${U.compressedMethod}`);
		return debug(`Decompress filename=${U.filename}, compressed-size=${W.length}`), G(await m.decompressDeflateRaw(W));
	}
	static async decompressDeflateRaw(m) {
		let U = new ReadableStream({ start(U) {
			U.enqueue(m), U.close();
		} }), W = new DecompressionStream("deflate-raw"), G = U.pipeThrough(W);
		try {
			let m = await new Response(G).arrayBuffer();
			return new Uint8Array(m);
		} catch (m) {
			let U = m instanceof Error ? `Failed to deflate ZIP entry: ${m.message}` : "Unknown decompression error in ZIP entry";
			throw TypeError(U);
		}
	}
	async readLocalFileHeader() {
		let m = await this.tokenizer.peekToken(UINT32_LE);
		if (m === Signature.LocalFileHeader) {
			let m = await this.tokenizer.readToken(LocalFileHeaderToken);
			return m.filename = await this.tokenizer.readToken(new StringType(m.filenameLength, "utf-8")), m;
		}
		if (m === Signature.CentralFileHeader) return !1;
		throw m === 3759263696 ? Error("Encrypted ZIP") : Error("Unexpected signature");
	}
};
function indexOf(m, U) {
	let W = m.length, G = U.length;
	if (G > W) return -1;
	for (let K = 0; K <= W - G; K++) {
		let W = !0;
		for (let q = 0; q < G; q++) if (m[K + q] !== U[q]) {
			W = !1;
			break;
		}
		if (W) return K;
	}
	return -1;
}
function mergeArrays(m) {
	let U = m.reduce((m, U) => m + U.length, 0), W = new Uint8Array(U), G = 0;
	for (let U of m) W.set(U, G), G += U.length;
	return W;
}
var GzipHandler = class {
	constructor(m) {
		this.tokenizer = m;
	}
	inflate() {
		let m = this.tokenizer;
		return new ReadableStream({ async pull(U) {
			let W = new Uint8Array(1024), G = await m.readBuffer(W, { mayBeLess: !0 });
			if (G === 0) {
				U.close();
				return;
			}
			U.enqueue(W.subarray(0, G));
		} }).pipeThrough(new DecompressionStream("gzip"));
	}
};
new globalThis.TextDecoder("utf8"), new globalThis.TextEncoder(), Array.from({ length: 256 }, (m, U) => U.toString(16).padStart(2, "0"));
function getUintBE(m) {
	let { byteLength: U } = m;
	if (U === 6) return m.getUint16(0) * 2 ** 32 + m.getUint32(2);
	if (U === 5) return m.getUint8(0) * 2 ** 32 + m.getUint32(1);
	if (U === 4) return m.getUint32(0);
	if (U === 3) return m.getUint8(0) * 2 ** 16 + m.getUint16(1);
	if (U === 2) return m.getUint16(0);
	if (U === 1) return m.getUint8(0);
}
function stringToBytes(m, U) {
	if (U === "utf-16le") {
		let U = [];
		for (let W = 0; W < m.length; W++) {
			let G = m.charCodeAt(W);
			U.push(G & 255, G >> 8 & 255);
		}
		return U;
	}
	if (U === "utf-16be") {
		let U = [];
		for (let W = 0; W < m.length; W++) {
			let G = m.charCodeAt(W);
			U.push(G >> 8 & 255, G & 255);
		}
		return U;
	}
	return [...m].map((m) => m.charCodeAt(0));
}
function tarHeaderChecksumMatches(m, U = 0) {
	let W = Number.parseInt(new StringType(6).get(m, 148).replace(/\0.*$/, "").trim(), 8);
	if (Number.isNaN(W)) return !1;
	let G = 256;
	for (let W = U; W < U + 148; W++) G += m[W];
	for (let W = U + 156; W < U + 512; W++) G += m[W];
	return W === G;
}
const uint32SyncSafeToken = {
	get: (m, U) => m[U + 3] & 127 | m[U + 2] << 7 | m[U + 1] << 14 | m[U] << 21,
	len: 4
}, reasonableDetectionSizeInBytes = 4100;
var maximumMpegOffsetTolerance = reasonableDetectionSizeInBytes - 2, maximumZipEntrySizeInBytes = 1024 * 1024, maximumZipEntryCount = 1024, maximumZipBufferedReadSizeInBytes = 2 ** 31 - 1, maximumUntrustedSkipSizeInBytes = 16 * 1024 * 1024, maximumUnknownSizePayloadProbeSizeInBytes = maximumZipEntrySizeInBytes, maximumZipTextEntrySizeInBytes = maximumZipEntrySizeInBytes, maximumNestedGzipDetectionSizeInBytes = maximumUntrustedSkipSizeInBytes, maximumNestedGzipProbeDepth = 1, unknownSizeGzipProbeTimeoutInMilliseconds = 100, maximumId3HeaderSizeInBytes = maximumUntrustedSkipSizeInBytes, maximumEbmlDocumentTypeSizeInBytes = 64, maximumEbmlElementPayloadSizeInBytes = maximumUnknownSizePayloadProbeSizeInBytes, maximumEbmlElementCount = 256, maximumPngChunkCount = 512, maximumPngStreamScanBudgetInBytes = maximumUntrustedSkipSizeInBytes, maximumAsfHeaderObjectCount = 512, maximumTiffTagCount = 512, maximumDetectionReentryCount = 256, maximumPngChunkSizeInBytes = maximumUnknownSizePayloadProbeSizeInBytes, maximumAsfHeaderPayloadSizeInBytes = maximumUnknownSizePayloadProbeSizeInBytes, maximumTiffStreamIfdOffsetInBytes = maximumUnknownSizePayloadProbeSizeInBytes, maximumTiffIfdOffsetInBytes = maximumUntrustedSkipSizeInBytes, recoverableZipErrorMessages = new Set([
	"Unexpected signature",
	"Encrypted ZIP",
	"Expected Central-File-Header signature"
]), recoverableZipErrorMessagePrefixes = [
	"ZIP entry count exceeds ",
	"Unsupported ZIP compression method:",
	"ZIP entry compressed data exceeds ",
	"ZIP entry decompressed data exceeds ",
	"Expected data-descriptor-signature at position "
], recoverableZipErrorCodes = new Set([
	"Z_BUF_ERROR",
	"Z_DATA_ERROR",
	"ERR_INVALID_STATE"
]), ParserHardLimitError = class extends Error {};
function patchWebByobTokenizerClose(m) {
	let U = m?.streamReader;
	if (U?.constructor?.name !== "WebStreamByobReader") return m;
	let { reader: W } = U, G = async () => {
		await W.cancel(), W.releaseLock();
	};
	return U.close = G, U.abort = async () => {
		U.interrupted = !0, await G();
	}, m;
}
function getSafeBound(m, U, W) {
	if (!Number.isFinite(m) || m < 0 || m > U) throw new ParserHardLimitError(`${W} has invalid size ${m} (maximum ${U} bytes)`);
	return m;
}
async function safeIgnore(m, U, { maximumLength: W = maximumUntrustedSkipSizeInBytes, reason: G = "skip" } = {}) {
	let K = getSafeBound(U, W, G);
	await m.ignore(K);
}
async function safeReadBuffer(m, U, W, { maximumLength: G = U.length, reason: K = "read" } = {}) {
	let q = getSafeBound(W?.length ?? U.length, G, K);
	return m.readBuffer(U, {
		...W,
		length: q
	});
}
async function decompressDeflateRawWithLimit(m, { maximumLength: U = maximumZipEntrySizeInBytes } = {}) {
	let W = new ReadableStream({ start(U) {
		U.enqueue(m), U.close();
	} }).pipeThrough(new DecompressionStream("deflate-raw")).getReader(), G = [], K = 0;
	try {
		for (;;) {
			let { done: m, value: q } = await W.read();
			if (m) break;
			if (K += q.length, K > U) throw await W.cancel(), Error(`ZIP entry decompressed data exceeds ${U} bytes`);
			G.push(q);
		}
	} finally {
		W.releaseLock();
	}
	let q = new Uint8Array(K), J = 0;
	for (let m of G) q.set(m, J), J += m.length;
	return q;
}
var zipDataDescriptorSignature = 134695760, zipDataDescriptorLengthInBytes = 16, zipDataDescriptorOverlapLengthInBytes = zipDataDescriptorLengthInBytes - 1;
function findZipDataDescriptorOffset(m, U) {
	if (m.length < zipDataDescriptorLengthInBytes) return -1;
	let W = m.length - zipDataDescriptorLengthInBytes;
	for (let G = 0; G <= W; G++) if (UINT32_LE.get(m, G) === zipDataDescriptorSignature && UINT32_LE.get(m, G + 8) === U + G) return G;
	return -1;
}
function isPngAncillaryChunk(m) {
	return (m.codePointAt(0) & 32) != 0;
}
function mergeByteChunks(m, U) {
	let W = new Uint8Array(U), G = 0;
	for (let U of m) W.set(U, G), G += U.length;
	return W;
}
async function readZipDataDescriptorEntryWithLimit(m, { shouldBuffer: U, maximumLength: W = maximumZipEntrySizeInBytes } = {}) {
	let { syncBuffer: G } = m, { length: K } = G, q = [], J = 0;
	for (;;) {
		let Y = await m.tokenizer.peekBuffer(G, { mayBeLess: !0 }), X = findZipDataDescriptorOffset(G.subarray(0, Y), J), Z = X >= 0 ? 0 : Y === K ? Math.min(zipDataDescriptorOverlapLengthInBytes, Y - 1) : 0, Q = X >= 0 ? X : Y - Z;
		if (Q === 0) break;
		if (J += Q, J > W) throw Error(`ZIP entry compressed data exceeds ${W} bytes`);
		if (U) {
			let U = new Uint8Array(Q);
			await m.tokenizer.readBuffer(U), q.push(U);
		} else await m.tokenizer.ignore(Q);
		if (X >= 0) break;
	}
	if (hasUnknownFileSize(m.tokenizer) || (m.knownSizeDescriptorScannedBytes += J), U) return mergeByteChunks(q, J);
}
function getRemainingZipScanBudget(m, U) {
	return hasUnknownFileSize(m.tokenizer) ? Math.max(0, maximumUntrustedSkipSizeInBytes - (m.tokenizer.position - U)) : Math.max(0, maximumZipEntrySizeInBytes - m.knownSizeDescriptorScannedBytes);
}
async function readZipEntryData(m, U, { shouldBuffer: W, maximumDescriptorLength: G = maximumZipEntrySizeInBytes } = {}) {
	if (U.dataDescriptor && U.compressedSize === 0) return readZipDataDescriptorEntryWithLimit(m, {
		shouldBuffer: W,
		maximumLength: G
	});
	if (!W) {
		await safeIgnore(m.tokenizer, U.compressedSize, {
			maximumLength: hasUnknownFileSize(m.tokenizer) ? maximumZipEntrySizeInBytes : m.tokenizer.fileInfo.size,
			reason: "ZIP entry compressed data"
		});
		return;
	}
	let K = getMaximumZipBufferedReadLength(m.tokenizer);
	if (!Number.isFinite(U.compressedSize) || U.compressedSize < 0 || U.compressedSize > K) throw Error(`ZIP entry compressed data exceeds ${K} bytes`);
	let q = new Uint8Array(U.compressedSize);
	return await m.tokenizer.readBuffer(q), q;
}
ZipHandler.prototype.inflate = async function(m, U, W) {
	if (m.compressedMethod === 0) return W(U);
	if (m.compressedMethod !== 8) throw Error(`Unsupported ZIP compression method: ${m.compressedMethod}`);
	return W(await decompressDeflateRawWithLimit(U, { maximumLength: maximumZipEntrySizeInBytes }));
}, ZipHandler.prototype.unzip = async function(m) {
	let U = !1, W = 0, G = this.tokenizer.position;
	this.knownSizeDescriptorScannedBytes = 0;
	do {
		if (hasExceededUnknownSizeScanBudget(this.tokenizer, G, maximumUntrustedSkipSizeInBytes)) throw new ParserHardLimitError(`ZIP stream probing exceeds ${maximumUntrustedSkipSizeInBytes} bytes`);
		let K = await this.readLocalFileHeader();
		if (!K) break;
		if (W++, W > maximumZipEntryCount) throw Error(`ZIP entry count exceeds ${maximumZipEntryCount}`);
		let q = m(K);
		U = !!q.stop, await this.tokenizer.ignore(K.extraFieldLength);
		let J = await readZipEntryData(this, K, {
			shouldBuffer: !!q.handler,
			maximumDescriptorLength: Math.min(maximumZipEntrySizeInBytes, getRemainingZipScanBudget(this, G))
		});
		if (q.handler && await this.inflate(K, J, q.handler), K.dataDescriptor) {
			let m = new Uint8Array(zipDataDescriptorLengthInBytes);
			if (await this.tokenizer.readBuffer(m), UINT32_LE.get(m, 0) !== zipDataDescriptorSignature) throw Error(`Expected data-descriptor-signature at position ${this.tokenizer.position - m.length}`);
		}
		if (hasExceededUnknownSizeScanBudget(this.tokenizer, G, maximumUntrustedSkipSizeInBytes)) throw new ParserHardLimitError(`ZIP stream probing exceeds ${maximumUntrustedSkipSizeInBytes} bytes`);
	} while (!U);
};
function createByteLimitedReadableStream(m, U) {
	let W = m.getReader(), G = 0, K = !1, q = !1, J = async (m) => {
		K || q || (q = !0, await W.cancel(m));
	};
	return new ReadableStream({
		async pull(m) {
			if (G >= U) {
				m.close(), await J();
				return;
			}
			let { done: q, value: Y } = await W.read();
			if (q || !Y) {
				K = !0, m.close();
				return;
			}
			let X = U - G;
			if (Y.length > X) {
				m.enqueue(Y.subarray(0, X)), G += X, m.close(), await J();
				return;
			}
			m.enqueue(Y), G += Y.length;
		},
		async cancel(m) {
			await J(m);
		}
	});
}
async function fileTypeFromBuffer(m, U) {
	return new FileTypeParser(U).fromBuffer(m);
}
async function fileTypeFromBlob(m, U) {
	return new FileTypeParser(U).fromBlob(m);
}
function getFileTypeFromMimeType(m) {
	switch (m = m.toLowerCase(), m) {
		case "application/epub+zip": return {
			ext: "epub",
			mime: m
		};
		case "application/vnd.oasis.opendocument.text": return {
			ext: "odt",
			mime: m
		};
		case "application/vnd.oasis.opendocument.text-template": return {
			ext: "ott",
			mime: m
		};
		case "application/vnd.oasis.opendocument.spreadsheet": return {
			ext: "ods",
			mime: m
		};
		case "application/vnd.oasis.opendocument.spreadsheet-template": return {
			ext: "ots",
			mime: m
		};
		case "application/vnd.oasis.opendocument.presentation": return {
			ext: "odp",
			mime: m
		};
		case "application/vnd.oasis.opendocument.presentation-template": return {
			ext: "otp",
			mime: m
		};
		case "application/vnd.oasis.opendocument.graphics": return {
			ext: "odg",
			mime: m
		};
		case "application/vnd.oasis.opendocument.graphics-template": return {
			ext: "otg",
			mime: m
		};
		case "application/vnd.openxmlformats-officedocument.presentationml.slideshow": return {
			ext: "ppsx",
			mime: m
		};
		case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": return {
			ext: "xlsx",
			mime: m
		};
		case "application/vnd.ms-excel.sheet.macroenabled": return {
			ext: "xlsm",
			mime: "application/vnd.ms-excel.sheet.macroenabled.12"
		};
		case "application/vnd.openxmlformats-officedocument.spreadsheetml.template": return {
			ext: "xltx",
			mime: m
		};
		case "application/vnd.ms-excel.template.macroenabled": return {
			ext: "xltm",
			mime: "application/vnd.ms-excel.template.macroenabled.12"
		};
		case "application/vnd.ms-powerpoint.slideshow.macroenabled": return {
			ext: "ppsm",
			mime: "application/vnd.ms-powerpoint.slideshow.macroenabled.12"
		};
		case "application/vnd.openxmlformats-officedocument.wordprocessingml.document": return {
			ext: "docx",
			mime: m
		};
		case "application/vnd.ms-word.document.macroenabled": return {
			ext: "docm",
			mime: "application/vnd.ms-word.document.macroenabled.12"
		};
		case "application/vnd.openxmlformats-officedocument.wordprocessingml.template": return {
			ext: "dotx",
			mime: m
		};
		case "application/vnd.ms-word.template.macroenabledtemplate": return {
			ext: "dotm",
			mime: "application/vnd.ms-word.template.macroenabled.12"
		};
		case "application/vnd.openxmlformats-officedocument.presentationml.template": return {
			ext: "potx",
			mime: m
		};
		case "application/vnd.ms-powerpoint.template.macroenabled": return {
			ext: "potm",
			mime: "application/vnd.ms-powerpoint.template.macroenabled.12"
		};
		case "application/vnd.openxmlformats-officedocument.presentationml.presentation": return {
			ext: "pptx",
			mime: m
		};
		case "application/vnd.ms-powerpoint.presentation.macroenabled": return {
			ext: "pptm",
			mime: "application/vnd.ms-powerpoint.presentation.macroenabled.12"
		};
		case "application/vnd.ms-visio.drawing": return {
			ext: "vsdx",
			mime: "application/vnd.visio"
		};
		case "application/vnd.ms-package.3dmanufacturing-3dmodel+xml": return {
			ext: "3mf",
			mime: "model/3mf"
		};
		default:
	}
}
function _check(m, U, W) {
	W = {
		offset: 0,
		...W
	};
	for (let [G, K] of U.entries()) if (W.mask) {
		if (K !== (W.mask[G] & m[G + W.offset])) return !1;
	} else if (K !== m[G + W.offset]) return !1;
	return !0;
}
function normalizeSampleSize(m) {
	return Number.isFinite(m) ? Math.max(1, Math.trunc(m)) : reasonableDetectionSizeInBytes;
}
function readByobReaderWithSignal(m, U, W) {
	return W === void 0 ? m.read(U) : (W.throwIfAborted(), new Promise((G, K) => {
		let q = () => {
			W.removeEventListener("abort", J);
		}, J = () => {
			let U = W.reason;
			q(), (async () => {
				try {
					await m.cancel(U);
				} catch {}
			})(), K(U);
		};
		W.addEventListener("abort", J, { once: !0 }), (async () => {
			try {
				let W = await m.read(U);
				q(), G(W);
			} catch (m) {
				q(), K(m);
			}
		})();
	}));
}
function normalizeMpegOffsetTolerance(m) {
	return Number.isFinite(m) ? Math.max(0, Math.min(maximumMpegOffsetTolerance, Math.trunc(m))) : 0;
}
function getKnownFileSizeOrMaximum(m) {
	return Number.isFinite(m) ? Math.max(0, m) : 2 ** 53 - 1;
}
function hasUnknownFileSize(m) {
	let U = m.fileInfo.size;
	return !Number.isFinite(U) || U === 2 ** 53 - 1;
}
function hasExceededUnknownSizeScanBudget(m, U, W) {
	return hasUnknownFileSize(m) && m.position - U > W;
}
function getMaximumZipBufferedReadLength(m) {
	let U = m.fileInfo.size, W = Number.isFinite(U) ? Math.max(0, U - m.position) : 2 ** 53 - 1;
	return Math.min(W, maximumZipBufferedReadSizeInBytes);
}
function isRecoverableZipError(m) {
	if (m instanceof EndOfStreamError || m instanceof ParserHardLimitError) return !0;
	if (!(m instanceof Error)) return !1;
	if (recoverableZipErrorMessages.has(m.message) || recoverableZipErrorCodes.has(m.code)) return !0;
	for (let U of recoverableZipErrorMessagePrefixes) if (m.message.startsWith(U)) return !0;
	return !1;
}
function canReadZipEntryForDetection(m, U = maximumZipEntrySizeInBytes) {
	let W = [m.compressedSize, m.uncompressedSize];
	for (let m of W) if (!Number.isFinite(m) || m < 0 || m > U) return !1;
	return !0;
}
function createOpenXmlZipDetectionState() {
	return {
		hasContentTypesEntry: !1,
		hasParsedContentTypesEntry: !1,
		isParsingContentTypes: !1,
		hasUnparseableContentTypes: !1,
		hasWordDirectory: !1,
		hasPresentationDirectory: !1,
		hasSpreadsheetDirectory: !1,
		hasThreeDimensionalModelEntry: !1
	};
}
function updateOpenXmlZipDetectionStateFromFilename(m, U) {
	U.startsWith("word/") && (m.hasWordDirectory = !0), U.startsWith("ppt/") && (m.hasPresentationDirectory = !0), U.startsWith("xl/") && (m.hasSpreadsheetDirectory = !0), U.startsWith("3D/") && U.endsWith(".model") && (m.hasThreeDimensionalModelEntry = !0);
}
function getOpenXmlFileTypeFromZipEntries(m) {
	if (!(!m.hasContentTypesEntry || m.hasUnparseableContentTypes || m.isParsingContentTypes || m.hasParsedContentTypesEntry)) {
		if (m.hasWordDirectory) return {
			ext: "docx",
			mime: "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
		};
		if (m.hasPresentationDirectory) return {
			ext: "pptx",
			mime: "application/vnd.openxmlformats-officedocument.presentationml.presentation"
		};
		if (m.hasSpreadsheetDirectory) return {
			ext: "xlsx",
			mime: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
		};
		if (m.hasThreeDimensionalModelEntry) return {
			ext: "3mf",
			mime: "model/3mf"
		};
	}
}
function getOpenXmlMimeTypeFromContentTypesXml(m) {
	let U = m.indexOf(".main+xml\"");
	if (U === -1) {
		let U = "application/vnd.ms-package.3dmanufacturing-3dmodel+xml";
		return m.includes(`ContentType="${U}"`) ? U : void 0;
	}
	let W = m.slice(0, U), G = W.lastIndexOf("\"");
	return W.slice(G + 1);
}
var FileTypeParser = class m {
	constructor(m) {
		let U = normalizeMpegOffsetTolerance(m?.mpegOffsetTolerance);
		this.options = {
			...m,
			mpegOffsetTolerance: U
		}, this.detectors = [
			...this.options.customDetectors ?? [],
			{
				id: "core",
				detect: this.detectConfident
			},
			{
				id: "core.imprecise",
				detect: this.detectImprecise
			}
		], this.tokenizerOptions = { abortSignal: this.options.signal }, this.gzipProbeDepth = 0;
	}
	getTokenizerOptions() {
		return { ...this.tokenizerOptions };
	}
	createTokenizerFromWebStream(m) {
		return patchWebByobTokenizerClose(fromWebStream(m, this.getTokenizerOptions()));
	}
	async parseTokenizer(m, U = 0) {
		this.detectionReentryCount = U;
		let W = m.position;
		for (let U of this.detectors) {
			let G;
			try {
				G = await U.detect(m);
			} catch (m) {
				if (m instanceof EndOfStreamError || m instanceof ParserHardLimitError) return;
				throw m;
			}
			if (G) return G;
			if (W !== m.position) return;
		}
	}
	async fromTokenizer(m) {
		try {
			return await this.parseTokenizer(m);
		} finally {
			await m.close();
		}
	}
	async fromBuffer(m) {
		if (!(m instanceof Uint8Array || m instanceof ArrayBuffer)) throw TypeError(`Expected the \`input\` argument to be of type \`Uint8Array\` or \`ArrayBuffer\`, got \`${typeof m}\``);
		let U = m instanceof Uint8Array ? m : new Uint8Array(m);
		if (U?.length > 1) return this.fromTokenizer(fromBuffer(U, this.getTokenizerOptions()));
	}
	async fromBlob(m) {
		this.options.signal?.throwIfAborted();
		let U = fromBlob(m, this.getTokenizerOptions());
		return this.fromTokenizer(U);
	}
	async fromStream(m) {
		this.options.signal?.throwIfAborted();
		let U = this.createTokenizerFromWebStream(m);
		return this.fromTokenizer(U);
	}
	async toDetectionStream(m, U) {
		let W = normalizeSampleSize(U?.sampleSize ?? 4100), G, K, q = m.getReader({ mode: "byob" });
		try {
			let { value: m, done: U } = await readByobReaderWithSignal(q, new Uint8Array(W), this.options.signal);
			if (K = m, !U && m) try {
				G = await this.fromBuffer(m.subarray(0, W));
			} catch (m) {
				if (!(m instanceof EndOfStreamError)) throw m;
				G = void 0;
			}
			K = m;
		} finally {
			q.releaseLock();
		}
		let J = new TransformStream({
			async start(m) {
				m.enqueue(K);
			},
			transform(m, U) {
				U.enqueue(m);
			}
		}), Y = m.pipeThrough(J);
		return Y.fileType = G, Y;
	}
	async detectGzip(U) {
		if (this.gzipProbeDepth >= maximumNestedGzipProbeDepth) return {
			ext: "gz",
			mime: "application/gzip"
		};
		let W = createByteLimitedReadableStream(new GzipHandler(U).inflate(), maximumNestedGzipDetectionSizeInBytes), G = hasUnknownFileSize(U), K, q, J, Y;
		if (G) {
			let U = new AbortController();
			K = setTimeout(() => {
				U.abort(new DOMException(`Operation timed out after ${unknownSizeGzipProbeTimeoutInMilliseconds} ms`, "TimeoutError"));
			}, unknownSizeGzipProbeTimeoutInMilliseconds), q = this.options.signal === void 0 ? U.signal : AbortSignal.any([this.options.signal, U.signal]), J = new m({
				...this.options,
				signal: q
			}), J.gzipProbeDepth = this.gzipProbeDepth + 1;
		} else this.gzipProbeDepth++;
		try {
			Y = await (J ?? this).fromStream(W);
		} catch (m) {
			if (m?.name === "AbortError" && q?.reason?.name !== "TimeoutError") throw m;
		} finally {
			clearTimeout(K), G || this.gzipProbeDepth--;
		}
		return Y?.ext === "tar" ? {
			ext: "tar.gz",
			mime: "application/gzip"
		} : {
			ext: "gz",
			mime: "application/gzip"
		};
	}
	check(m, U) {
		return _check(this.buffer, m, U);
	}
	checkString(m, U) {
		return this.check(stringToBytes(m, U?.encoding), U);
	}
	detectConfident = async (m) => {
		if (this.buffer = new Uint8Array(reasonableDetectionSizeInBytes), m.fileInfo.size === void 0 && (m.fileInfo.size = 2 ** 53 - 1), this.tokenizer = m, hasUnknownFileSize(m) && (await m.peekBuffer(this.buffer, {
			length: 3,
			mayBeLess: !0
		}), this.check([
			31,
			139,
			8
		]))) return this.detectGzip(m);
		if (await m.peekBuffer(this.buffer, {
			length: 32,
			mayBeLess: !0
		}), this.check([66, 77])) return {
			ext: "bmp",
			mime: "image/bmp"
		};
		if (this.check([11, 119])) return {
			ext: "ac3",
			mime: "audio/vnd.dolby.dd-raw"
		};
		if (this.check([120, 1])) return {
			ext: "dmg",
			mime: "application/x-apple-diskimage"
		};
		if (this.check([77, 90])) return {
			ext: "exe",
			mime: "application/x-msdownload"
		};
		if (this.check([37, 33])) return await m.peekBuffer(this.buffer, {
			length: 24,
			mayBeLess: !0
		}), this.checkString("PS-Adobe-", { offset: 2 }) && this.checkString(" EPSF-", { offset: 14 }) ? {
			ext: "eps",
			mime: "application/eps"
		} : {
			ext: "ps",
			mime: "application/postscript"
		};
		if (this.check([31, 160]) || this.check([31, 157])) return {
			ext: "Z",
			mime: "application/x-compress"
		};
		if (this.check([199, 113])) return {
			ext: "cpio",
			mime: "application/x-cpio"
		};
		if (this.check([96, 234])) return {
			ext: "arj",
			mime: "application/x-arj"
		};
		if (this.check([
			239,
			187,
			191
		])) return this.detectionReentryCount >= maximumDetectionReentryCount ? void 0 : (this.detectionReentryCount++, await this.tokenizer.ignore(3), this.detectConfident(m));
		if (this.check([
			71,
			73,
			70
		])) return {
			ext: "gif",
			mime: "image/gif"
		};
		if (this.check([
			73,
			73,
			188
		])) return {
			ext: "jxr",
			mime: "image/vnd.ms-photo"
		};
		if (this.check([
			31,
			139,
			8
		])) return this.detectGzip(m);
		if (this.check([
			66,
			90,
			104
		])) return {
			ext: "bz2",
			mime: "application/x-bzip2"
		};
		if (this.checkString("ID3")) {
			await safeIgnore(m, 6, {
				maximumLength: 6,
				reason: "ID3 header prefix"
			});
			let U = await m.readToken(uint32SyncSafeToken), W = hasUnknownFileSize(m);
			if (!Number.isFinite(U) || U < 0 || W && (U > maximumId3HeaderSizeInBytes || m.position + U > maximumId3HeaderSizeInBytes)) return;
			if (m.position + U > m.fileInfo.size) return W ? void 0 : {
				ext: "mp3",
				mime: "audio/mpeg"
			};
			try {
				await safeIgnore(m, U, {
					maximumLength: W ? maximumId3HeaderSizeInBytes : m.fileInfo.size,
					reason: "ID3 payload"
				});
			} catch (m) {
				if (m instanceof EndOfStreamError) return;
				throw m;
			}
			return this.detectionReentryCount >= maximumDetectionReentryCount ? void 0 : (this.detectionReentryCount++, this.parseTokenizer(m, this.detectionReentryCount));
		}
		if (this.checkString("MP+")) return {
			ext: "mpc",
			mime: "audio/x-musepack"
		};
		if ((this.buffer[0] === 67 || this.buffer[0] === 70) && this.check([87, 83], { offset: 1 })) return {
			ext: "swf",
			mime: "application/x-shockwave-flash"
		};
		if (this.check([
			255,
			216,
			255
		])) return this.check([247], { offset: 3 }) ? {
			ext: "jls",
			mime: "image/jls"
		} : {
			ext: "jpg",
			mime: "image/jpeg"
		};
		if (this.check([
			79,
			98,
			106,
			1
		])) return {
			ext: "avro",
			mime: "application/avro"
		};
		if (this.checkString("FLIF")) return {
			ext: "flif",
			mime: "image/flif"
		};
		if (this.checkString("8BPS")) return {
			ext: "psd",
			mime: "image/vnd.adobe.photoshop"
		};
		if (this.checkString("MPCK")) return {
			ext: "mpc",
			mime: "audio/x-musepack"
		};
		if (this.checkString("FORM")) return {
			ext: "aif",
			mime: "audio/aiff"
		};
		if (this.checkString("icns", { offset: 0 })) return {
			ext: "icns",
			mime: "image/icns"
		};
		if (this.check([
			80,
			75,
			3,
			4
		])) {
			let U, W = createOpenXmlZipDetectionState();
			try {
				await new ZipHandler(m).unzip((m) => {
					updateOpenXmlZipDetectionStateFromFilename(W, m.filename);
					let G = m.filename === "[Content_Types].xml", K = getOpenXmlFileTypeFromZipEntries(W);
					if (!G && K) return U = K, { stop: !0 };
					switch (m.filename) {
						case "META-INF/mozilla.rsa": return U = {
							ext: "xpi",
							mime: "application/x-xpinstall"
						}, { stop: !0 };
						case "META-INF/MANIFEST.MF": return U = {
							ext: "jar",
							mime: "application/java-archive"
						}, { stop: !0 };
						case "mimetype": return canReadZipEntryForDetection(m, maximumZipTextEntrySizeInBytes) ? {
							async handler(m) {
								U = getFileTypeFromMimeType(new TextDecoder("utf-8").decode(m).trim());
							},
							stop: !0
						} : {};
						case "[Content_Types].xml": return W.hasContentTypesEntry = !0, canReadZipEntryForDetection(m, maximumZipTextEntrySizeInBytes) ? (W.isParsingContentTypes = !0, {
							async handler(m) {
								let G = getOpenXmlMimeTypeFromContentTypesXml(new TextDecoder("utf-8").decode(m));
								G && (U = getFileTypeFromMimeType(G)), W.hasParsedContentTypesEntry = !0, W.isParsingContentTypes = !1;
							},
							stop: !0
						}) : (W.hasUnparseableContentTypes = !0, {});
						default: return /classes\d*\.dex/.test(m.filename) ? (U = {
							ext: "apk",
							mime: "application/vnd.android.package-archive"
						}, { stop: !0 }) : {};
					}
				});
			} catch (m) {
				if (!isRecoverableZipError(m)) throw m;
				W.isParsingContentTypes && (W.isParsingContentTypes = !1, W.hasUnparseableContentTypes = !0);
			}
			return U ?? getOpenXmlFileTypeFromZipEntries(W) ?? {
				ext: "zip",
				mime: "application/zip"
			};
		}
		if (this.checkString("OggS")) {
			await m.ignore(28);
			let U = new Uint8Array(8);
			return await m.readBuffer(U), _check(U, [
				79,
				112,
				117,
				115,
				72,
				101,
				97,
				100
			]) ? {
				ext: "opus",
				mime: "audio/ogg; codecs=opus"
			} : _check(U, [
				128,
				116,
				104,
				101,
				111,
				114,
				97
			]) ? {
				ext: "ogv",
				mime: "video/ogg"
			} : _check(U, [
				1,
				118,
				105,
				100,
				101,
				111,
				0
			]) ? {
				ext: "ogm",
				mime: "video/ogg"
			} : _check(U, [
				127,
				70,
				76,
				65,
				67
			]) ? {
				ext: "oga",
				mime: "audio/ogg"
			} : _check(U, [
				83,
				112,
				101,
				101,
				120,
				32,
				32
			]) ? {
				ext: "spx",
				mime: "audio/ogg"
			} : _check(U, [
				1,
				118,
				111,
				114,
				98,
				105,
				115
			]) ? {
				ext: "ogg",
				mime: "audio/ogg"
			} : {
				ext: "ogx",
				mime: "application/ogg"
			};
		}
		if (this.check([80, 75]) && (this.buffer[2] === 3 || this.buffer[2] === 5 || this.buffer[2] === 7) && (this.buffer[3] === 4 || this.buffer[3] === 6 || this.buffer[3] === 8)) return {
			ext: "zip",
			mime: "application/zip"
		};
		if (this.checkString("MThd")) return {
			ext: "mid",
			mime: "audio/midi"
		};
		if (this.checkString("wOFF") && (this.check([
			0,
			1,
			0,
			0
		], { offset: 4 }) || this.checkString("OTTO", { offset: 4 }))) return {
			ext: "woff",
			mime: "font/woff"
		};
		if (this.checkString("wOF2") && (this.check([
			0,
			1,
			0,
			0
		], { offset: 4 }) || this.checkString("OTTO", { offset: 4 }))) return {
			ext: "woff2",
			mime: "font/woff2"
		};
		if (this.check([
			212,
			195,
			178,
			161
		]) || this.check([
			161,
			178,
			195,
			212
		])) return {
			ext: "pcap",
			mime: "application/vnd.tcpdump.pcap"
		};
		if (this.checkString("DSD ")) return {
			ext: "dsf",
			mime: "audio/x-dsf"
		};
		if (this.checkString("LZIP")) return {
			ext: "lz",
			mime: "application/x-lzip"
		};
		if (this.checkString("fLaC")) return {
			ext: "flac",
			mime: "audio/flac"
		};
		if (this.check([
			66,
			80,
			71,
			251
		])) return {
			ext: "bpg",
			mime: "image/bpg"
		};
		if (this.checkString("wvpk")) return {
			ext: "wv",
			mime: "audio/wavpack"
		};
		if (this.checkString("%PDF")) return {
			ext: "pdf",
			mime: "application/pdf"
		};
		if (this.check([
			0,
			97,
			115,
			109
		])) return {
			ext: "wasm",
			mime: "application/wasm"
		};
		if (this.check([73, 73])) {
			let m = await this.readTiffHeader(!1);
			if (m) return m;
		}
		if (this.check([77, 77])) {
			let m = await this.readTiffHeader(!0);
			if (m) return m;
		}
		if (this.checkString("MAC ")) return {
			ext: "ape",
			mime: "audio/ape"
		};
		if (this.check([
			26,
			69,
			223,
			163
		])) {
			async function U() {
				let U = await m.peekNumber(UINT8), W = 128, G = 0;
				for (; (U & W) === 0 && W !== 0;) ++G, W >>= 1;
				let K = new Uint8Array(G + 1);
				return await safeReadBuffer(m, K, void 0, {
					maximumLength: K.length,
					reason: "EBML field"
				}), K;
			}
			async function W() {
				let m = await U(), W = await U();
				W[0] ^= 128 >> W.length - 1;
				let G = Math.min(6, W.length), K = new DataView(m.buffer), q = new DataView(W.buffer, W.length - G, G);
				return {
					id: getUintBE(K),
					len: getUintBE(q)
				};
			}
			async function G(U) {
				let G = 0;
				for (; U > 0;) {
					if (G++, G > maximumEbmlElementCount || hasExceededUnknownSizeScanBudget(m, q, maximumUntrustedSkipSizeInBytes)) return;
					let K = m.position, J = await W();
					if (J.id === 17026) {
						if (J.len > maximumEbmlDocumentTypeSizeInBytes) return;
						let U = getSafeBound(J.len, maximumEbmlDocumentTypeSizeInBytes, "EBML DocType");
						return (await m.readToken(new StringType(U))).replaceAll(/\00.*$/g, "");
					}
					if (hasUnknownFileSize(m) && (!Number.isFinite(J.len) || J.len < 0 || J.len > maximumEbmlElementPayloadSizeInBytes) || (await safeIgnore(m, J.len, {
						maximumLength: hasUnknownFileSize(m) ? maximumEbmlElementPayloadSizeInBytes : m.fileInfo.size,
						reason: "EBML payload"
					}), --U, m.position <= K)) return;
				}
			}
			let K = await W(), q = m.position;
			switch (await G(K.len)) {
				case "webm": return {
					ext: "webm",
					mime: "video/webm"
				};
				case "matroska": return {
					ext: "mkv",
					mime: "video/matroska"
				};
				default: return;
			}
		}
		if (this.checkString("SQLi")) return {
			ext: "sqlite",
			mime: "application/x-sqlite3"
		};
		if (this.check([
			78,
			69,
			83,
			26
		])) return {
			ext: "nes",
			mime: "application/x-nintendo-nes-rom"
		};
		if (this.checkString("Cr24")) return {
			ext: "crx",
			mime: "application/x-google-chrome-extension"
		};
		if (this.checkString("MSCF") || this.checkString("ISc(")) return {
			ext: "cab",
			mime: "application/vnd.ms-cab-compressed"
		};
		if (this.check([
			237,
			171,
			238,
			219
		])) return {
			ext: "rpm",
			mime: "application/x-rpm"
		};
		if (this.check([
			197,
			208,
			211,
			198
		])) return {
			ext: "eps",
			mime: "application/eps"
		};
		if (this.check([
			40,
			181,
			47,
			253
		])) return {
			ext: "zst",
			mime: "application/zstd"
		};
		if (this.check([
			127,
			69,
			76,
			70
		])) return {
			ext: "elf",
			mime: "application/x-elf"
		};
		if (this.check([
			33,
			66,
			68,
			78
		])) return {
			ext: "pst",
			mime: "application/vnd.ms-outlook"
		};
		if (this.checkString("PAR1") || this.checkString("PARE")) return {
			ext: "parquet",
			mime: "application/vnd.apache.parquet"
		};
		if (this.checkString("ttcf")) return {
			ext: "ttc",
			mime: "font/collection"
		};
		if (this.check([
			254,
			237,
			250,
			206
		]) || this.check([
			254,
			237,
			250,
			207
		]) || this.check([
			206,
			250,
			237,
			254
		]) || this.check([
			207,
			250,
			237,
			254
		])) return {
			ext: "macho",
			mime: "application/x-mach-binary"
		};
		if (this.check([
			4,
			34,
			77,
			24
		])) return {
			ext: "lz4",
			mime: "application/x-lz4"
		};
		if (this.checkString("regf")) return {
			ext: "dat",
			mime: "application/x-ft-windows-registry-hive"
		};
		if (this.checkString("$FL2") || this.checkString("$FL3")) return {
			ext: "sav",
			mime: "application/x-spss-sav"
		};
		if (this.check([
			79,
			84,
			84,
			79,
			0
		])) return {
			ext: "otf",
			mime: "font/otf"
		};
		if (this.checkString("#!AMR")) return {
			ext: "amr",
			mime: "audio/amr"
		};
		if (this.checkString("{\\rtf")) return {
			ext: "rtf",
			mime: "application/rtf"
		};
		if (this.check([
			70,
			76,
			86,
			1
		])) return {
			ext: "flv",
			mime: "video/x-flv"
		};
		if (this.checkString("IMPM")) return {
			ext: "it",
			mime: "audio/x-it"
		};
		if (this.checkString("-lh0-", { offset: 2 }) || this.checkString("-lh1-", { offset: 2 }) || this.checkString("-lh2-", { offset: 2 }) || this.checkString("-lh3-", { offset: 2 }) || this.checkString("-lh4-", { offset: 2 }) || this.checkString("-lh5-", { offset: 2 }) || this.checkString("-lh6-", { offset: 2 }) || this.checkString("-lh7-", { offset: 2 }) || this.checkString("-lzs-", { offset: 2 }) || this.checkString("-lz4-", { offset: 2 }) || this.checkString("-lz5-", { offset: 2 }) || this.checkString("-lhd-", { offset: 2 })) return {
			ext: "lzh",
			mime: "application/x-lzh-compressed"
		};
		if (this.check([
			0,
			0,
			1,
			186
		])) {
			if (this.check([33], {
				offset: 4,
				mask: [241]
			})) return {
				ext: "mpg",
				mime: "video/MP1S"
			};
			if (this.check([68], {
				offset: 4,
				mask: [196]
			})) return {
				ext: "mpg",
				mime: "video/MP2P"
			};
		}
		if (this.checkString("ITSF")) return {
			ext: "chm",
			mime: "application/vnd.ms-htmlhelp"
		};
		if (this.check([
			202,
			254,
			186,
			190
		])) {
			let m = UINT32_BE.get(this.buffer, 4), U = UINT16_BE.get(this.buffer, 6);
			if (m > 0 && m <= 30) return {
				ext: "macho",
				mime: "application/x-mach-binary"
			};
			if (U > 30) return {
				ext: "class",
				mime: "application/java-vm"
			};
		}
		if (this.checkString(".RMF")) return {
			ext: "rm",
			mime: "application/vnd.rn-realmedia"
		};
		if (this.checkString("DRACO")) return {
			ext: "drc",
			mime: "application/vnd.google.draco"
		};
		if (this.check([
			253,
			55,
			122,
			88,
			90,
			0
		])) return {
			ext: "xz",
			mime: "application/x-xz"
		};
		if (this.checkString("<?xml ")) return {
			ext: "xml",
			mime: "application/xml"
		};
		if (this.check([
			55,
			122,
			188,
			175,
			39,
			28
		])) return {
			ext: "7z",
			mime: "application/x-7z-compressed"
		};
		if (this.check([
			82,
			97,
			114,
			33,
			26,
			7
		]) && (this.buffer[6] === 0 || this.buffer[6] === 1)) return {
			ext: "rar",
			mime: "application/x-rar-compressed"
		};
		if (this.checkString("solid ")) return {
			ext: "stl",
			mime: "model/stl"
		};
		if (this.checkString("AC")) {
			let m = new StringType(4, "latin1").get(this.buffer, 2);
			if (m.match("^d*") && m >= 1e3 && m <= 1050) return {
				ext: "dwg",
				mime: "image/vnd.dwg"
			};
		}
		if (this.checkString("070707")) return {
			ext: "cpio",
			mime: "application/x-cpio"
		};
		if (this.checkString("BLENDER")) return {
			ext: "blend",
			mime: "application/x-blender"
		};
		if (this.checkString("!<arch>")) return await m.ignore(8), await m.readToken(new StringType(13, "ascii")) === "debian-binary" ? {
			ext: "deb",
			mime: "application/x-deb"
		} : {
			ext: "ar",
			mime: "application/x-unix-archive"
		};
		if (this.checkString("WEBVTT") && [
			"\n",
			"\r",
			"	",
			" ",
			"\0"
		].some((m) => this.checkString(m, { offset: 6 }))) return {
			ext: "vtt",
			mime: "text/vtt"
		};
		if (this.check([
			137,
			80,
			78,
			71,
			13,
			10,
			26,
			10
		])) {
			let U = {
				ext: "png",
				mime: "image/png"
			}, W = {
				ext: "apng",
				mime: "image/apng"
			};
			await m.ignore(8);
			async function G() {
				return {
					length: await m.readToken(INT32_BE),
					type: await m.readToken(new StringType(4, "latin1"))
				};
			}
			let K = hasUnknownFileSize(m), q = m.position, J = 0, Y = !1;
			do {
				if (J++, J > maximumPngChunkCount || hasExceededUnknownSizeScanBudget(m, q, maximumPngStreamScanBudgetInBytes)) break;
				let X = m.position, Z = await G();
				if (Z.length < 0) return;
				if (Z.type === "IHDR") {
					if (Z.length !== 13) return;
					Y = !0;
				}
				switch (Z.type) {
					case "IDAT": return U;
					case "acTL": return W;
					default:
						if (!Y && Z.type !== "CgBI") return;
						if (K && Z.length > maximumPngChunkSizeInBytes) return Y && isPngAncillaryChunk(Z.type) ? U : void 0;
						try {
							await safeIgnore(m, Z.length + 4, {
								maximumLength: K ? maximumPngChunkSizeInBytes + 4 : m.fileInfo.size,
								reason: "PNG chunk payload"
							});
						} catch (m) {
							if (!K && (m instanceof ParserHardLimitError || m instanceof EndOfStreamError)) return U;
							throw m;
						}
				}
				if (m.position <= X) break;
			} while (m.position + 8 < m.fileInfo.size);
			return U;
		}
		if (this.check([
			65,
			82,
			82,
			79,
			87,
			49,
			0,
			0
		])) return {
			ext: "arrow",
			mime: "application/vnd.apache.arrow.file"
		};
		if (this.check([
			103,
			108,
			84,
			70,
			2,
			0,
			0,
			0
		])) return {
			ext: "glb",
			mime: "model/gltf-binary"
		};
		if (this.check([
			102,
			114,
			101,
			101
		], { offset: 4 }) || this.check([
			109,
			100,
			97,
			116
		], { offset: 4 }) || this.check([
			109,
			111,
			111,
			118
		], { offset: 4 }) || this.check([
			119,
			105,
			100,
			101
		], { offset: 4 })) return {
			ext: "mov",
			mime: "video/quicktime"
		};
		if (this.check([
			73,
			73,
			82,
			79,
			8,
			0,
			0,
			0,
			24
		])) return {
			ext: "orf",
			mime: "image/x-olympus-orf"
		};
		if (this.checkString("gimp xcf ")) return {
			ext: "xcf",
			mime: "image/x-xcf"
		};
		if (this.checkString("ftyp", { offset: 4 }) && this.buffer[8] & 96) {
			let m = new StringType(4, "latin1").get(this.buffer, 8).replace("\0", " ").trim();
			switch (m) {
				case "avif":
				case "avis": return {
					ext: "avif",
					mime: "image/avif"
				};
				case "mif1": return {
					ext: "heic",
					mime: "image/heif"
				};
				case "msf1": return {
					ext: "heic",
					mime: "image/heif-sequence"
				};
				case "heic":
				case "heix": return {
					ext: "heic",
					mime: "image/heic"
				};
				case "hevc":
				case "hevx": return {
					ext: "heic",
					mime: "image/heic-sequence"
				};
				case "qt": return {
					ext: "mov",
					mime: "video/quicktime"
				};
				case "M4V":
				case "M4VH":
				case "M4VP": return {
					ext: "m4v",
					mime: "video/x-m4v"
				};
				case "M4P": return {
					ext: "m4p",
					mime: "video/mp4"
				};
				case "M4B": return {
					ext: "m4b",
					mime: "audio/mp4"
				};
				case "M4A": return {
					ext: "m4a",
					mime: "audio/x-m4a"
				};
				case "F4V": return {
					ext: "f4v",
					mime: "video/mp4"
				};
				case "F4P": return {
					ext: "f4p",
					mime: "video/mp4"
				};
				case "F4A": return {
					ext: "f4a",
					mime: "audio/mp4"
				};
				case "F4B": return {
					ext: "f4b",
					mime: "audio/mp4"
				};
				case "crx": return {
					ext: "cr3",
					mime: "image/x-canon-cr3"
				};
				default: return m.startsWith("3g") ? m.startsWith("3g2") ? {
					ext: "3g2",
					mime: "video/3gpp2"
				} : {
					ext: "3gp",
					mime: "video/3gpp"
				} : {
					ext: "mp4",
					mime: "video/mp4"
				};
			}
		}
		if (this.checkString("REGEDIT4\r\n")) return {
			ext: "reg",
			mime: "application/x-ms-regedit"
		};
		if (this.check([
			82,
			73,
			70,
			70
		])) {
			if (this.checkString("WEBP", { offset: 8 })) return {
				ext: "webp",
				mime: "image/webp"
			};
			if (this.check([
				65,
				86,
				73
			], { offset: 8 })) return {
				ext: "avi",
				mime: "video/vnd.avi"
			};
			if (this.check([
				87,
				65,
				86,
				69
			], { offset: 8 })) return {
				ext: "wav",
				mime: "audio/wav"
			};
			if (this.check([
				81,
				76,
				67,
				77
			], { offset: 8 })) return {
				ext: "qcp",
				mime: "audio/qcelp"
			};
		}
		if (this.check([
			73,
			73,
			85,
			0,
			24,
			0,
			0,
			0,
			136,
			231,
			116,
			216
		])) return {
			ext: "rw2",
			mime: "image/x-panasonic-rw2"
		};
		if (this.check([
			48,
			38,
			178,
			117,
			142,
			102,
			207,
			17,
			166,
			217
		])) {
			let U = !1;
			try {
				async function W() {
					let U = new Uint8Array(16);
					return await safeReadBuffer(m, U, void 0, {
						maximumLength: U.length,
						reason: "ASF header GUID"
					}), {
						id: U,
						size: Number(await m.readToken(UINT64_LE))
					};
				}
				await safeIgnore(m, 30, {
					maximumLength: 30,
					reason: "ASF header prelude"
				});
				let G = hasUnknownFileSize(m), K = m.position, q = 0;
				for (; m.position + 24 < m.fileInfo.size && (q++, !(q > maximumAsfHeaderObjectCount || hasExceededUnknownSizeScanBudget(m, K, maximumUntrustedSkipSizeInBytes)));) {
					let K = m.position, q = await W(), J = q.size - 24;
					if (!Number.isFinite(J) || J < 0) {
						U = !0;
						break;
					}
					if (_check(q.id, [
						145,
						7,
						220,
						183,
						183,
						169,
						207,
						17,
						142,
						230,
						0,
						192,
						12,
						32,
						83,
						101
					])) {
						let U = new Uint8Array(16);
						if (J -= await safeReadBuffer(m, U, void 0, {
							maximumLength: U.length,
							reason: "ASF stream type GUID"
						}), _check(U, [
							64,
							158,
							105,
							248,
							77,
							91,
							207,
							17,
							168,
							253,
							0,
							128,
							95,
							92,
							68,
							43
						])) return {
							ext: "asf",
							mime: "audio/x-ms-asf"
						};
						if (_check(U, [
							192,
							239,
							25,
							188,
							77,
							91,
							207,
							17,
							168,
							253,
							0,
							128,
							95,
							92,
							68,
							43
						])) return {
							ext: "asf",
							mime: "video/x-ms-asf"
						};
						break;
					}
					if (G && J > maximumAsfHeaderPayloadSizeInBytes) {
						U = !0;
						break;
					}
					if (await safeIgnore(m, J, {
						maximumLength: G ? maximumAsfHeaderPayloadSizeInBytes : m.fileInfo.size,
						reason: "ASF header payload"
					}), m.position <= K) {
						U = !0;
						break;
					}
				}
			} catch (W) {
				if (W instanceof EndOfStreamError || W instanceof ParserHardLimitError) hasUnknownFileSize(m) && (U = !0);
				else throw W;
			}
			return U ? void 0 : {
				ext: "asf",
				mime: "application/vnd.ms-asf"
			};
		}
		if (this.check([
			171,
			75,
			84,
			88,
			32,
			49,
			49,
			187,
			13,
			10,
			26,
			10
		])) return {
			ext: "ktx",
			mime: "image/ktx"
		};
		if ((this.check([
			126,
			16,
			4
		]) || this.check([
			126,
			24,
			4
		])) && this.check([
			48,
			77,
			73,
			69
		], { offset: 4 })) return {
			ext: "mie",
			mime: "application/x-mie"
		};
		if (this.check([
			39,
			10,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		], { offset: 2 })) return {
			ext: "shp",
			mime: "application/x-esri-shape"
		};
		if (this.check([
			255,
			79,
			255,
			81
		])) return {
			ext: "j2c",
			mime: "image/j2c"
		};
		if (this.check([
			0,
			0,
			0,
			12,
			106,
			80,
			32,
			32,
			13,
			10,
			135,
			10
		])) switch (await m.ignore(20), await m.readToken(new StringType(4, "ascii"))) {
			case "jp2 ": return {
				ext: "jp2",
				mime: "image/jp2"
			};
			case "jpx ": return {
				ext: "jpx",
				mime: "image/jpx"
			};
			case "jpm ": return {
				ext: "jpm",
				mime: "image/jpm"
			};
			case "mjp2": return {
				ext: "mj2",
				mime: "image/mj2"
			};
			default: return;
		}
		if (this.check([255, 10]) || this.check([
			0,
			0,
			0,
			12,
			74,
			88,
			76,
			32,
			13,
			10,
			135,
			10
		])) return {
			ext: "jxl",
			mime: "image/jxl"
		};
		if (this.check([254, 255])) return this.checkString("<?xml ", {
			offset: 2,
			encoding: "utf-16be"
		}) ? {
			ext: "xml",
			mime: "application/xml"
		} : void 0;
		if (this.check([
			208,
			207,
			17,
			224,
			161,
			177,
			26,
			225
		])) return {
			ext: "cfb",
			mime: "application/x-cfb"
		};
		if (await m.peekBuffer(this.buffer, {
			length: Math.min(256, m.fileInfo.size),
			mayBeLess: !0
		}), this.check([
			97,
			99,
			115,
			112
		], { offset: 36 })) return {
			ext: "icc",
			mime: "application/vnd.iccprofile"
		};
		if (this.checkString("**ACE", { offset: 7 }) && this.checkString("**", { offset: 12 })) return {
			ext: "ace",
			mime: "application/x-ace-compressed"
		};
		if (this.checkString("BEGIN:")) {
			if (this.checkString("VCARD", { offset: 6 })) return {
				ext: "vcf",
				mime: "text/vcard"
			};
			if (this.checkString("VCALENDAR", { offset: 6 })) return {
				ext: "ics",
				mime: "text/calendar"
			};
		}
		if (this.checkString("FUJIFILMCCD-RAW")) return {
			ext: "raf",
			mime: "image/x-fujifilm-raf"
		};
		if (this.checkString("Extended Module:")) return {
			ext: "xm",
			mime: "audio/x-xm"
		};
		if (this.checkString("Creative Voice File")) return {
			ext: "voc",
			mime: "audio/x-voc"
		};
		if (this.check([
			4,
			0,
			0,
			0
		]) && this.buffer.length >= 16) {
			let m = new DataView(this.buffer.buffer).getUint32(12, !0);
			if (m > 12 && this.buffer.length >= m + 16) try {
				let U = new TextDecoder().decode(this.buffer.subarray(16, m + 16));
				if (JSON.parse(U).files) return {
					ext: "asar",
					mime: "application/x-asar"
				};
			} catch {}
		}
		if (this.check([
			6,
			14,
			43,
			52,
			2,
			5,
			1,
			1,
			13,
			1,
			2,
			1,
			1,
			2
		])) return {
			ext: "mxf",
			mime: "application/mxf"
		};
		if (this.checkString("SCRM", { offset: 44 })) return {
			ext: "s3m",
			mime: "audio/x-s3m"
		};
		if (this.check([71]) && this.check([71], { offset: 188 }) || this.check([71], { offset: 4 }) && this.check([71], { offset: 196 })) return {
			ext: "mts",
			mime: "video/mp2t"
		};
		if (this.check([
			66,
			79,
			79,
			75,
			77,
			79,
			66,
			73
		], { offset: 60 })) return {
			ext: "mobi",
			mime: "application/x-mobipocket-ebook"
		};
		if (this.check([
			68,
			73,
			67,
			77
		], { offset: 128 })) return {
			ext: "dcm",
			mime: "application/dicom"
		};
		if (this.check([
			76,
			0,
			0,
			0,
			1,
			20,
			2,
			0,
			0,
			0,
			0,
			0,
			192,
			0,
			0,
			0,
			0,
			0,
			0,
			70
		])) return {
			ext: "lnk",
			mime: "application/x.ms.shortcut"
		};
		if (this.check([
			98,
			111,
			111,
			107,
			0,
			0,
			0,
			0,
			109,
			97,
			114,
			107,
			0,
			0,
			0,
			0
		])) return {
			ext: "alias",
			mime: "application/x.apple.alias"
		};
		if (this.checkString("Kaydara FBX Binary  \0")) return {
			ext: "fbx",
			mime: "application/x.autodesk.fbx"
		};
		if (this.check([76, 80], { offset: 34 }) && (this.check([
			0,
			0,
			1
		], { offset: 8 }) || this.check([
			1,
			0,
			2
		], { offset: 8 }) || this.check([
			2,
			0,
			2
		], { offset: 8 }))) return {
			ext: "eot",
			mime: "application/vnd.ms-fontobject"
		};
		if (this.check([
			6,
			6,
			237,
			245,
			216,
			29,
			70,
			229,
			189,
			49,
			239,
			231,
			254,
			116,
			183,
			29
		])) return {
			ext: "indd",
			mime: "application/x-indesign"
		};
		if (this.check([
			255,
			255,
			0,
			0,
			7,
			0,
			0,
			0,
			4,
			0,
			0,
			0,
			1,
			0,
			1,
			0
		]) || this.check([
			0,
			0,
			255,
			255,
			0,
			0,
			0,
			7,
			0,
			0,
			0,
			4,
			0,
			1,
			0,
			1
		])) return {
			ext: "jmp",
			mime: "application/x-jmp-data"
		};
		if (await m.peekBuffer(this.buffer, {
			length: Math.min(512, m.fileInfo.size),
			mayBeLess: !0
		}), this.checkString("ustar", { offset: 257 }) && (this.checkString("\0", { offset: 262 }) || this.checkString(" ", { offset: 262 })) || this.check([
			0,
			0,
			0,
			0,
			0,
			0
		], { offset: 257 }) && tarHeaderChecksumMatches(this.buffer)) return {
			ext: "tar",
			mime: "application/x-tar"
		};
		if (this.check([255, 254])) {
			let m = "utf-16le";
			return this.checkString("<?xml ", {
				offset: 2,
				encoding: m
			}) ? {
				ext: "xml",
				mime: "application/xml"
			} : this.check([255, 14], { offset: 2 }) && this.checkString("SketchUp Model", {
				offset: 4,
				encoding: m
			}) ? {
				ext: "skp",
				mime: "application/vnd.sketchup.skp"
			} : this.checkString("Windows Registry Editor Version 5.00\r\n", {
				offset: 2,
				encoding: m
			}) ? {
				ext: "reg",
				mime: "application/x-ms-regedit"
			} : void 0;
		}
		if (this.checkString("-----BEGIN PGP MESSAGE-----")) return {
			ext: "pgp",
			mime: "application/pgp-encrypted"
		};
	};
	detectImprecise = async (m) => {
		this.buffer = new Uint8Array(reasonableDetectionSizeInBytes);
		let U = getKnownFileSizeOrMaximum(m.fileInfo.size);
		if (await m.peekBuffer(this.buffer, {
			length: Math.min(8, U),
			mayBeLess: !0
		}), this.check([
			0,
			0,
			1,
			186
		]) || this.check([
			0,
			0,
			1,
			179
		])) return {
			ext: "mpg",
			mime: "video/mpeg"
		};
		if (this.check([
			0,
			1,
			0,
			0,
			0
		])) return {
			ext: "ttf",
			mime: "font/ttf"
		};
		if (this.check([
			0,
			0,
			1,
			0
		])) return {
			ext: "ico",
			mime: "image/x-icon"
		};
		if (this.check([
			0,
			0,
			2,
			0
		])) return {
			ext: "cur",
			mime: "image/x-icon"
		};
		if (await m.peekBuffer(this.buffer, {
			length: Math.min(2 + this.options.mpegOffsetTolerance, U),
			mayBeLess: !0
		}), this.buffer.length >= 2 + this.options.mpegOffsetTolerance) for (let m = 0; m <= this.options.mpegOffsetTolerance; ++m) {
			let U = this.scanMpeg(m);
			if (U) return U;
		}
	};
	async readTiffTag(m) {
		let U = await this.tokenizer.readToken(m ? UINT16_BE : UINT16_LE);
		switch (await this.tokenizer.ignore(10), U) {
			case 50341: return {
				ext: "arw",
				mime: "image/x-sony-arw"
			};
			case 50706: return {
				ext: "dng",
				mime: "image/x-adobe-dng"
			};
			default:
		}
	}
	async readTiffIFD(m) {
		let U = await this.tokenizer.readToken(m ? UINT16_BE : UINT16_LE);
		if (!(U > maximumTiffTagCount) && !(hasUnknownFileSize(this.tokenizer) && 2 + U * 12 > maximumTiffIfdOffsetInBytes)) for (let W = 0; W < U; ++W) {
			let U = await this.readTiffTag(m);
			if (U) return U;
		}
	}
	async readTiffHeader(m) {
		let U = {
			ext: "tif",
			mime: "image/tiff"
		}, W = (m ? UINT16_BE : UINT16_LE).get(this.buffer, 2), G = (m ? UINT32_BE : UINT32_LE).get(this.buffer, 4);
		if (W === 42) {
			if (G >= 6) {
				if (this.checkString("CR", { offset: 8 })) return {
					ext: "cr2",
					mime: "image/x-canon-cr2"
				};
				if (G >= 8) {
					let U = (m ? UINT16_BE : UINT16_LE).get(this.buffer, 8), W = (m ? UINT16_BE : UINT16_LE).get(this.buffer, 10);
					if (U === 28 && W === 254 || U === 31 && W === 11) return {
						ext: "nef",
						mime: "image/x-nikon-nef"
					};
				}
			}
			if (hasUnknownFileSize(this.tokenizer) && G > maximumTiffStreamIfdOffsetInBytes) return U;
			let W = hasUnknownFileSize(this.tokenizer) ? maximumTiffIfdOffsetInBytes : this.tokenizer.fileInfo.size;
			try {
				await safeIgnore(this.tokenizer, G, {
					maximumLength: W,
					reason: "TIFF IFD offset"
				});
			} catch (m) {
				if (m instanceof EndOfStreamError) return;
				throw m;
			}
			let K;
			try {
				K = await this.readTiffIFD(m);
			} catch (m) {
				if (m instanceof EndOfStreamError) return;
				throw m;
			}
			return K ?? U;
		}
		if (W === 43) return U;
	}
	scanMpeg(m) {
		if (this.check([255, 224], {
			offset: m,
			mask: [255, 224]
		})) {
			if (this.check([16], {
				offset: m + 1,
				mask: [22]
			})) return this.check([8], {
				offset: m + 1,
				mask: [8]
			}), {
				ext: "aac",
				mime: "audio/aac"
			};
			if (this.check([2], {
				offset: m + 1,
				mask: [6]
			})) return {
				ext: "mp3",
				mime: "audio/mpeg"
			};
			if (this.check([4], {
				offset: m + 1,
				mask: [6]
			})) return {
				ext: "mp2",
				mime: "audio/mpeg"
			};
			if (this.check([6], {
				offset: m + 1,
				mask: [6]
			})) return {
				ext: "mp1",
				mime: "audio/mpeg"
			};
		}
	}
};
export { reasonableDetectionSizeInBytes as a, __toESM as c, normalizeSampleSize as i, fileTypeFromBlob as n, __commonJSMin as o, fileTypeFromBuffer as r, __export as s, FileTypeParser as t };

//# sourceMappingURL=core-Cet55PGg.js.map